module.exports = __webpack_public_path__ + "img/5.7.Chla.4d6c6390.png";